
import React from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-vegana-primary">Política de Privacidad (RGPD)</h1>
        
        <Card className="mb-8">
          <CardContent className="pt-6">
            <div className="prose max-w-none">
              <div className="mb-6 text-sm text-gray-500">
                Última actualización: 7 de abril de 2025
              </div>
              
              <p className="mb-4">
                En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos, 
                te informamos de lo siguiente:
              </p>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">1. Responsable del tratamiento:</h2>
                <p>
                  Ruth Medina Marza<br />
                  Domicilio: Onda, Castellón, España<br />
                  Email de contacto: <a href="mailto:info@guiavegana.es" className="text-vegana-primary">info@guiavegana.es</a>
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">2. Datos que recogemos:</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Nombre y apellidos</li>
                  <li>Dirección de correo electrónico</li>
                  <li>Peso, altura, objetivos nutricionales</li>
                  <li>Alergias o intolerancias alimentarias</li>
                  <li>Datos de pago (procesados por Stripe)</li>
                  <li>Información de uso en la app (registro de alimentos, favoritos, interacción con el chatbot)</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">3. Finalidad del tratamiento:</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Proporcionar asesoramiento nutricional personalizado</li>
                  <li>Generar menús y recomendaciones personalizadas</li>
                  <li>Enviar comunicaciones informativas o comerciales</li>
                  <li>Analizar el uso de la app y mejorar el servicio</li>
                  <li>Gestionar pagos y suscripciones</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">4. Base legal:</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Ejecución del contrato (uso de la app)</li>
                  <li>Consentimiento del usuario</li>
                  <li>Interés legítimo (mejoras del servicio, marketing propio)</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">5. Destinatarios de los datos:</h2>
                <p className="mb-2">Tus datos podrán ser compartidos con:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Stripe (gestión de pagos)</li>
                  <li>MailerLite (envío de emails)</li>
                  <li>Meta y Google Analytics (análisis y publicidad)</li>
                  <li>OpenAI (procesamiento del chatbot)</li>
                  <li>El equipo interno de nutricionistas (sin acceso a datos de pago)</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">6. Conservación de los datos:</h2>
                <p>
                  Los datos se conservarán mientras esté activa la cuenta del usuario o mientras haya 
                  obligación legal. Puedes solicitar su eliminación escribiendo a <a href="mailto:info@guiavegana.es" className="text-vegana-primary">info@guiavegana.es</a>
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">7. Derechos del usuario:</h2>
                <p>
                  Puedes ejercer tus derechos de acceso, rectificación, supresión, portabilidad, limitación 
                  u oposición escribiéndonos al correo anterior. También puedes presentar una reclamación 
                  ante la <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-vegana-primary">AEPD (www.aepd.es)</a>.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">8. Seguridad:</h2>
                <p>
                  Adoptamos medidas técnicas y organizativas para proteger tu información personal contra 
                  accesos no autorizados, pérdida o alteración.
                </p>
              </section>
              
              <div className="mt-8 text-center">
                <Link to="/" className="text-vegana-primary hover:underline">
                  Volver a Inicio
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
